var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16666 0.208008C3.67934 0.208008 0.0416565 3.84569 0.0416565 8.33301C0.0416565 12.8203 3.67934 16.458 8.16666 16.458C12.654 16.458 16.2917 12.8203 16.2917 8.33301C16.2917 3.84569 12.654 0.208008 8.16666 0.208008ZM1.29166 8.33301C1.29166 4.53605 4.3697 1.45801 8.16666 1.45801C11.9636 1.45801 15.0417 4.53605 15.0417 8.33301C15.0417 12.13 11.9636 15.208 8.16666 15.208C4.3697 15.208 1.29166 12.13 1.29166 8.33301Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2753 14.5578C15.0312 14.3137 14.6355 14.3137 14.3914 14.5578C14.1474 14.8019 14.1474 15.1976 14.3914 15.4417L17.7247 18.775C17.9688 19.0191 18.3645 19.0191 18.6086 18.775C18.8526 18.5309 18.8526 18.1352 18.6086 17.8911L15.2753 14.5578Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.e4dee70c7e442e7359c8a973d5d8f4a2.svg";
export { ForwardRef as ReactComponent };